import { Navigate, useLocation, useParams } from "react-router";

export function RedirectCheckoutRedesign() {
  const { search } = useLocation();
  return <Navigate to={`/checkout${search}`} replace />;
}

export function RedirectToCart() {
  return <Navigate to="/cart" replace />;
}

export function RedirectToWishlist() {
  return <Navigate to="/wishlist" replace />;
}

export function RedirectToOrders() {
  return <Navigate to="/orders" replace />;
}

/** Old `/product/:slug` bookmarks and links redirect to canonical `/view/:slug`. */
export function RedirectProductSlugToView() {
  const { product_slug } = useParams<{ product_slug: string }>();
  const { search, hash } = useLocation();
  if (!product_slug) return <Navigate to="/" replace />;
  return <Navigate to={`/view/${product_slug}${search}${hash}`} replace />;
}
